<template>
  <div :class="$setClasses">
    <p v-if="!meeting">
      {{ $t('meeting.subtitle', { duration: duration }) }}
    </p>
    <template v-else>
      <p>{{ $t('meeting.wish') }}</p>
      <p :class="$vClass('meeting')">{{ newMeetingDate }}</p>
      <div :class="$vClass('button-wrapper')">
        <nxt-core-btn
          :aria-label="$t('meeting.booking')"
          :class="[$vPrefix('btn'), $vPrefix('btn--meeting')]"
          :disabled="isMeetingLoading"
          @click="handlerPostMeeting(meeting)">
          <span :class="buttonLabel">{{ $t('meeting.booking') }}</span>
          <span
            v-if="isMeetingLoading"
            :class="[$vPrefix('btn--meeting__spinner'), $vPrefix('btn__spinner')]">
            <font-awesome-icon :class="$vPrefix('spinner')" :icon="['fa', 'circle-notch']"/>
          </span>
        </nxt-core-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { usePartnerStore } from '../../store/partnerStore.ts';

export default {
  name: 'MeetingDisplay',
  nameClassStyle: 'meeting-display',
  props: {
    meeting: {
      type: Object,
    },
    isMeetingLoading: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState(usePartnerStore, ['duration']),
    newMeetingDate() {
      return this.$t('meeting.infoDate', {
        date: this.$helpers.format.formatDate(new Date(this.meeting.start)),
        start: this.$helpers.format.formatHours(this.meeting.start),
        end: this.$helpers.format.formatHours(this.meeting.end),
      });
    },
    buttonLabel() {
      return {
        [this.$vPrefix('btn__label--loading')]: this.isMeetingLoading,
      };
    },
  },
  methods: {
    ...mapActions(usePartnerStore, [
      'postMeeting',
    ]),
    async handlerPostMeeting(meeting) {
      try {
        await this.postMeeting(meeting);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.#{$prefixName}meeting-display {
  border-radius: var(--nxt-border-radius-base);
  padding: var(--nxt-space-default);
  margin: var(--nxt-space-default) auto;
  max-width: 520px;
  text-align: center;
  background-color: #f4f5f7;

  &__meeting {
    text-align: center;
    align-items: center;
    font-size: var(--nxt-font-size-xlarge);
    font-weight: var(--nxt-font-weight-bold);
  }

  &__button__wrapper {
    text-align: center;
  }
}
</style>
